import React from 'react';
import {Motion, spring} from 'react-motion';

import PropTypes from 'prop-types';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {QuotaReachedIcon} from 'shells/icon/svg/quota-reached-icon';

import styles from './bar-gauge.module.css';

const TODAY_BAR_WIDTH = 6;

BarGauge.propTypes = {
    hasQuota: PropTypes.bool.isRequired,
    percentComplete: PropTypes.number,
    statusTooltip: PropTypes.string,
    currentPercentToEndTime: PropTypes.number,
    shouldRenderTodayLabel: PropTypes.bool,
};
export function BarGauge(props) {
    if (!props.hasQuota) {
        return <div className={styles['empty-bar']} />;
    }

    return (
        <div className={styles['bar-container']}>
            {renderCurrentStatus(Math.min(props.percentComplete, 1), props.currentPercentToEndTime)}
            {renderGoalLine(
                props.currentPercentToEndTime,
                props.shouldRenderTodayLabel,
                props.statusTooltip
            )}
            {renderQuotaReached(props.percentComplete)}
        </div>
    );
}

function renderCurrentStatus(percentComplete, currentPercentToEndTime) {
    const statusColor = percentComplete > currentPercentToEndTime ? colors.green : colors.rose;
    const percentWidth = Math.min(percentComplete * 100, 100);

    return (
        <Motion style={{x: spring(percentWidth)}}>
            {(interpolatedStyle) => {
                return (
                    <div
                        style={{width: `${interpolatedStyle.x}%`, backgroundColor: statusColor}}
                        className={styles['current-bar']}
                    />
                );
            }}
        </Motion>
    );
}

function renderGoalLine(currentPercentToEndTime, shouldRenderLabel, tooltip) {
    const left = `calc(${currentPercentToEndTime * 100}% - ${TODAY_BAR_WIDTH / 2}px)`;

    return (
        <div
            style={{left}}
            data-tip='Quota benchmark'
            title={tooltip}
            className={styles['goal-line-container']}
        >
            <div className={shouldRenderLabel ? styles['goal-line-short'] : styles['goal-line']} />
            {shouldRenderLabel ? renderTodayLabel(currentPercentToEndTime) : undefined}
        </div>
    );
}

function renderTodayLabel(percent) {
    let style;
    if (percent > 0.96) {
        style = 'today-label-right';
    } else if (percent < 0.03) {
        style = 'today-label-left';
    } else {
        style = 'today-label';
    }

    return (
        <div className={styles['today-label-container']}>
            <div className={style}>Today</div>
        </div>
    );
}

function renderQuotaReached(percentComplete) {
    if (percentComplete >= 1) {
        return (
            <div className={styles['quota-reached-icon']}>
                <QuotaReachedIcon height={20} />
            </div>
        );
    }
}
